/**
 * wishlist.js — Sam's Store UAE v3
 * Slide-in drawer triggered by the header heart icon.
 * Items saved to localStorage — no login, no page needed.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'sam_wishlist_v1';

    /* ── Storage ── */
    function getList() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
        catch (e) { return []; }
    }

    function saveList(list) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
        catch (e) { }
    }

    function isWishlisted(handle) { return getList().indexOf(handle) !== -1; }

    function toggleWishlist(handle) {
        var list = getList();
        var idx = list.indexOf(handle);
        if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
        saveList(list);
        return idx === -1;
    }

    /* ── Build the drawer DOM once ── */
    var drawer, overlay;

    function buildDrawer() {
        if (drawer) return;

        overlay = document.createElement('div');
        overlay.className = 'sam-wl-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.addEventListener('click', closeDrawer);

        drawer = document.createElement('div');
        drawer.className = 'sam-wl-drawer';
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-label', 'Wishlist');
        drawer.innerHTML = [
            '<div class="sam-wl-drawer__header">',
            '  <div style="display:flex;align-items:baseline;gap:2px">',
            '    <h2 class="sam-wl-drawer__title">Wishlist</h2>',
            '    <span class="sam-wl-drawer__count" id="sam-wl-count"></span>',
            '  </div>',
            '  <button class="sam-wl-drawer__close" id="sam-wl-close" aria-label="Close wishlist">',
            '    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">',
            '      <path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
            '    </svg>',
            '  </button>',
            '</div>',
            '<div class="sam-wl-drawer__body" id="sam-wl-body"></div>'
        ].join('');

        document.body.appendChild(overlay);
        document.body.appendChild(drawer);
        document.getElementById('sam-wl-close').addEventListener('click', closeDrawer);

        /* Close on Escape */
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
        });
    }

    /* ── Open / Close ── */
    function openDrawer() {
        buildDrawer();
        renderDrawerItems();
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        overlay.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        overlay.setAttribute('aria-hidden', 'true');
    }

    /* ── Render items inside drawer ── */
    function renderDrawerItems() {
        var body = document.getElementById('sam-wl-body');
        var countEl = document.getElementById('sam-wl-count');
        if (!body) return;

        var list = getList();
        if (countEl) countEl.textContent = list.length > 0 ? '(' + list.length + ')' : '';

        if (list.length === 0) {
            body.innerHTML = [
                '<div class="sam-wl-drawer__empty">',
                '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
                '    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>',
                '  </svg>',
                '  <p>Your wishlist is empty</p>',
                '  <p style="font-size:1.2rem;opacity:0.6">Tap the ♡ on any product to save it here</p>',
                '</div>'
            ].join('');
            return;
        }

        body.innerHTML = '<div class="sam-wl-drawer__loading">Loading…</div>';
        var loaded = 0;
        var items = [];

        list.forEach(function (handle, i) {
            fetch('/products/' + handle + '.js')
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (p) {
                    if (p) items[i] = p;
                })
                .catch(function () { })
                .finally(function () {
                    loaded++;
                    if (loaded === list.length) renderItems(items, list);
                });
        });
    }

    function renderItems(items, handles) {
        var body = document.getElementById('sam-wl-body');
        if (!body) return;
        body.innerHTML = '';

        var hasItems = false;
        items.forEach(function (p, i) {
            if (!p) return;
            hasItems = true;
            var handle = handles[i];
            var img = p.images && p.images[0] ? p.images[0] : '';
            var price = 'AED ' + (p.price / 100).toFixed(2);

            var row = document.createElement('div');
            row.className = 'sam-wl-item';
            row.setAttribute('data-wl-handle', handle);
            row.innerHTML = [
                '<a href="/products/' + p.handle + '" class="sam-wl-item__img-link">',
                img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" class="sam-wl-item__img">' : '',
                '</a>',
                '<div class="sam-wl-item__info">',
                '  <a href="/products/' + p.handle + '" class="sam-wl-item__name">' + escapeHtml(p.title) + '</a>',
                '  <span class="sam-wl-item__price">' + price + '</span>',
                '  <div class="sam-wl-item__actions">',
                '    <a href="/products/' + p.handle + '" class="sam-wl-item__view">View Product</a>',
                '    <button class="sam-wl-item__remove" type="button" data-remove="' + handle + '">Remove</button>',
                '  </div>',
                '</div>'
            ].join('');

            row.querySelector('.sam-wl-item__remove').addEventListener('click', function () {
                toggleWishlist(handle);
                row.style.opacity = '0';
                row.style.transition = 'opacity 0.2s';
                setTimeout(function () {
                    row.remove();
                    syncAllHearts(handle, false);
                    updateHeaderBadge();
                    /* If now empty, re-render */
                    var body2 = document.getElementById('sam-wl-body');
                    if (body2 && !body2.querySelector('.sam-wl-item')) renderDrawerItems();
                }, 200);
            });

            body.appendChild(row);
        });

        if (!hasItems) renderDrawerItems(); /* show empty state */
    }

    function escapeHtml(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /* ── Create heart button ── */
    function createHeart(handle, isActive) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sam-wishlist-btn' + (isActive ? ' is-active' : '');
        btn.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
        btn.setAttribute('data-wishlist-handle', handle);
        btn.innerHTML = svgHeart(isActive);

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var active = toggleWishlist(handle);
            syncAllHearts(handle, active);
            updateHeaderBadge();
            btn.classList.add('sam-wishlist-btn--pop');
            setTimeout(function () { btn.classList.remove('sam-wishlist-btn--pop'); }, 300);
        });
        return btn;
    }

    function svgHeart(filled) {
        return '<svg viewBox="0 0 24 24" fill="' + (filled ? 'currentColor' : 'none') + '" width="18" height="18" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function syncAllHearts(handle, active) {
        document.querySelectorAll('[data-wishlist-handle="' + handle + '"]').forEach(function (btn) {
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
            var svg = btn.querySelector('svg');
            if (svg) svg.outerHTML = svgHeart(active);
        });
    }

    /* ── Header badge ── */
    function updateHeaderBadge() {
        var badge = document.getElementById('sam-header-wl-badge');
        if (!badge) return;
        var count = getList().length;
        badge.textContent = count > 0 ? (count > 99 ? '99+' : count) : '';
        badge.style.display = count > 0 ? '' : 'none';
        /* Fix #18: pop animation when badge updates */
        if (count > 0) {
            badge.classList.remove('is-popping');
            void badge.offsetWidth; /* force reflow to restart animation */
            badge.classList.add('is-popping');
            setTimeout(function(){ badge.classList.remove('is-popping'); }, 400);
        }
        if (drawer && drawer.classList.contains('is-open')) {
            var countEl = document.getElementById('sam-wl-count');
            if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
        }
    }

    /* ── Inject hearts into product cards ── */
    function injectHearts() {
        /* Standard card-wrapper cards (collection pages, search, etc.) */
        document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
            if (wrapper.querySelector('.sam-wishlist-btn')) return;
            /* Find handle via card link */
            var link = wrapper.querySelector('a[href*="/products/"]');
            if (!link) return;
            var m = link.getAttribute('href').match(/\/products\/([^?#"]+)/);
            if (!m) return;
            var handle = m[1];

            var btn = createHeart(handle, isWishlisted(handle));
            /*
             * Append to .card-wrapper (the outermost element), NOT to .card__media.
             * Reason: .card__media has overflow:hidden (clips buttons at edges) and
             * Dawn's full-bleed anchor <a class="full-unstyled-link"> comes later in the
             * DOM and paints over anything inside .card__media.
             * By appending to .card-wrapper as the LAST child, our button is painted
             * after the full-bleed anchor in natural stacking order — no z-index war needed.
             */
            wrapper.style.position = wrapper.style.position || 'relative';
            wrapper.appendChild(btn);
        });

        /* sam-featured-products cards */
        document.querySelectorAll('[data-sfp-card]').forEach(function (card) {
            if (card.querySelector('.sam-wishlist-btn')) return;
            var media = card.querySelector('[data-sfp-media]');
            if (!media) return;
            var url = media.getAttribute('data-url') || '';
            var m = url.match(/\/products\/([^?#"]+)/);
            if (!m) return;
            media.appendChild(createHeart(m[1], isWishlisted(m[1])));
        });

        /* Product page */
        var gallery = document.querySelector('.product__media-wrapper');
        if (gallery && !gallery.querySelector('.sam-wishlist-btn')) {
            var canon = document.querySelector('link[rel="canonical"]');
            if (canon) {
                var m2 = canon.href.match(/\/products\/([^?#"]+)/);
                if (m2) {
                    var pgBtn = createHeart(m2[1], isWishlisted(m2[1]));
                    pgBtn.classList.add('sam-wishlist-btn--lg');
                    gallery.appendChild(pgBtn);
                }
            }
        }
    }

    /* ── Wire header wishlist icon to open drawer ── */
    function wireHeaderIcon() {
        var icon = document.getElementById('sam-header-wishlist');
        if (!icon) return;
        icon.addEventListener('click', function (e) {
            e.preventDefault();
            openDrawer();
        });
    }

    /* ── Render wishlist on dedicated page (if /pages/wishlist exists) ── */
    function renderWishlistPage() {
        var container = document.getElementById('sam-wishlist-page');
        if (!container) return;
        var list = getList();
        if (list.length === 0) {
            container.innerHTML = '<p class="sam-wl-empty">Your wishlist is empty. Click the ♡ on any product to save it here.</p>';
            return;
        }
        container.innerHTML = '<div class="sam-wl-loading">Loading your wishlist…</div>';
        var grid = document.createElement('div');
        grid.className = 'sam-wl-grid';
        var done = 0;
        list.forEach(function (handle) {
            fetch('/products/' + handle + '.js')
                .then(function (r) { return r.json(); })
                .then(function (p) {
                    var img = p.images[0] || '';
                    var card = document.createElement('div');
                    card.className = 'sam-wl-card';
                    card.innerHTML = [
                        '<a href="/products/' + p.handle + '" class="sam-wl-img-link">',
                        img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" class="sam-wl-img">' : '',
                        '</a>',
                        '<div class="sam-wl-info">',
                        '<a href="/products/' + p.handle + '" class="sam-wl-name">' + escapeHtml(p.title) + '</a>',
                        '<span class="sam-wl-price">AED ' + (p.price / 100).toFixed(2) + '</span>',
                        '<button class="sam-wl-remove" data-remove="' + handle + '">Remove</button>',
                        '</div>'
                    ].join('');
                    card.querySelector('.sam-wl-remove').addEventListener('click', function () {
                        toggleWishlist(handle);
                        card.remove();
                        updateHeaderBadge();
                        if (!grid.children.length) container.innerHTML = '<p class="sam-wl-empty">Your wishlist is empty.</p>';
                    });
                    grid.appendChild(card);
                })
                .catch(function () { })
                .finally(function () {
                    done++;
                    if (done === list.length) { container.innerHTML = ''; container.appendChild(grid); }
                });
        });
    }

    /* ── Init ── */
    function init() {
        wireHeaderIcon();
        updateHeaderBadge();
        injectHearts();
        renderWishlistPage();
        document.addEventListener('infinite-scroll:products-added', injectHearts);
    }

    window.__samWlInit = renderWishlistPage;
    window.__samWlOpen = openDrawer;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.dispatchEvent(new CustomEvent('sam:wishlist:ready'));
})();
